'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.queryURL = queryURL;

exports.default = function () {
  var defaults = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var context = {};

  if (!defaults.headers) defaults.headers = {};

  context.defaults = defaults;

  var host = defaults.host || '';

  var query = function query(params) {
    var arr = [];
    for (var p in params) {
      if (params.hasOwnProperty(p)) {
        arr.push(encodeURIComponent(p) + "=" + encodeURIComponent(params[p]));
      }
    }

    return arr.length > 0 ? arr.join('&') : '';
  };

  context.request = function (resource, method) {
    var body = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];

    method = method.toUpperCase();

    var args = {
      method: method,
      headers: {}
    };

    //Options & defaults
    for (var key in context.defaults) {
      if (key != 'headers') {
        args[key] = defaults[key];
      }
    }

    for (var key in options) {
      if (key != 'headers') {
        args[key] = options[key];
      }
    }

    // end Options & defaults
    for (var key in options.headers) {
      args.headers[key] = options.headers[key];
    }

    for (var key in context.defaults.headers) {
      args.headers[key] = defaults.headers[key];
    }

    if (!args.headers['Content-Type'] && args.headers['Content-Type'] !== false) {
      args.headers['Content-Type'] = 'application/json';
    }

    if (method != 'GET') args.body = (typeof body === 'undefined' ? 'undefined' : _typeof(body)) == 'object' ? JSON.stringify(body) : body;

    if (context.defaults.transforms && context.defaults.transforms.forEach) {
      context.defaults.transforms.forEach(function (t) {
        args = t(args);
      });
    }

    return (0, _isomorphicFetch2.default)(host + resource, args);
  };

  context.get = function (resource) {
    var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
    var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

    var qs = query(params);
    return context.request(queryURL(resource, qs), 'GET', {}, options);
  };

  var updateMethod = function updateMethod(method) {
    context[method] = function (resource) {
      var body = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
      var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

      return context.request(resource, method.toUpperCase(), body, options);
    };
  };

  ['put', 'patch', 'post'].forEach(function (item) {
    return updateMethod(item);
  });

  context.del = function (resource) {
    var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
    var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

    var qs = query(params);
    return context.request(queryURL(resource, qs), 'DELETE', {}, options);
  };

  return context;
};

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function queryURL(resource, qs) {
  if (!qs.length) return resource;

  var joinWith = '?';
  if (resource.indexOf('?') > -1) joinWith = '&';

  return qs.length ? [resource, qs].join(joinWith) : resource;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/http-otro/lib/client.js
// module id = U0d1
// module chunks = 0